export default {
  custom_button: {
    continue: "Continue",
  },
  text_inputs: {
    door_name: {
      placeholder: "Door name (optional)",
    },
    company_name: {
      placeholder: "Company name (optional)",
    },
    note: {
      placeholder: "Add delivery instructions e.g. call at arrival (optional)",
    },
    order_instruction: {
      placeholder: 'Enter order instructions...',
    },
  },
  error_messages: {
    update_profile_unsuccessful: "Failed to update your profile",
  },
};
